var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('menu-options-item',{attrs:{"close":"","label":"Abrir","icon":"folder-open"},on:{"click":function($event){return _vm.$emit('abrir')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }